/**
 * This is a subset of enum `Placements`
 */var ComboboxPlacements;
(function (ComboboxPlacements) {
  ComboboxPlacements["BottomStart"] = 'bottom-start';
  ComboboxPlacements["TopStart"] = 'top-start';
})(ComboboxPlacements || (ComboboxPlacements = {}));
export { ComboboxPlacements };